import React from "react";
import { useSelector } from "react-redux";
import * as mq from "../../styles/mediaQueries";
import styled from "styled-components";

const FeatureSectionContext = React.createContext();
FeatureSectionContext.displayName = "FeatureSectionContext";

export function useFeatureSection() {
  const context = React.useContext(FeatureSectionContext);

  if (!context)
    throw new Error(
      "`useFeature must be used within FeatureSectionContextProvider",
    );

  return context;
}
function FeatureSection({ heading = "", children, ...props }) {
  const { childCount } = useSelector(state => state.compare);
  return (
    <FeatureSectionContext.Provider value={{ heading }}>
      <StyledSectionWrap noChild={!childCount[heading]} {...props}>
        <GradientHeading>{heading}</GradientHeading>
        <SectionContent>{children}</SectionContent>
      </StyledSectionWrap>
    </FeatureSectionContext.Provider>
  );
}

export { FeatureSection };

const StyledSectionWrap = styled.section`
  display: ${props => props.noChild && "none"};
  margin-top: 2em;
  padding: 1.6em;
  box-shadow: rgb(0 0 0 / 16%) 0px 5px 15px 0px;
  ${mq.sm} {
    padding: 0.87em;
    margin-top: 1em;
  }
`;

const GradientHeading = styled.h2`
  background-image: linear-gradient(to right, var(--primary-color-light), #fff);
  padding: 0.76em 0.93em;
  color: var(--primary-color);
  text-transform: uppercase;
  font-family: "Inter";
  font-weight: 700;
  font-size: 1.06rem;
  width: max-content;
  ${mq.sm} {
    width: 80%;
    font-size: 0.7rem;
  }
`;

const SectionContent = styled.div`
  margin-top: 1em;
`;
